export type UiExperience = 'classic' | 'fjord';
export const UI_EXPERIENCE_KEY = 'experviser-ui-experience';

/** The build kill switch wins over any browser preference. No CRM data lives here. */
export function resolveUiExperience(search: string, stored: string | null, enabled = true): UiExperience {
  if (!enabled) return 'classic';
  const requested = new URLSearchParams(search).get('ui');
  if (requested === 'classic' || requested === 'fjord') return requested;
  return stored === 'classic' ? 'classic' : 'fjord';
}

export function initializeUiExperience(): UiExperience {
  let stored: string | null = null;
  try { stored = window.localStorage.getItem(UI_EXPERIENCE_KEY); } catch { /* URL recovery works without storage. */ }
  // A previous recovery action could have left `classic` in localStorage. It
  // must never silently downgrade a normal CRM visit to the retired surface.
  const migratedStored = stored === 'classic' ? null : stored;
  const experience = resolveUiExperience(window.location.search, migratedStored, import.meta.env.VITE_FJORD_UI_ENABLED !== 'false');
  const requested = new URLSearchParams(window.location.search).get('ui');
  if (requested === 'classic' || requested === 'fjord') {
    try { window.localStorage.setItem(UI_EXPERIENCE_KEY, experience); } catch { /* Keep the URL override for this load. */ }
  } else if (experience === 'fjord') {
    try { window.localStorage.setItem(UI_EXPERIENCE_KEY, 'fjord'); } catch { /* Keep the in-memory selection. */ }
  }
  document.documentElement.dataset.ui = experience;
  return experience;
}

export function isFjordUi(): boolean {
  return document.documentElement.dataset.ui === 'fjord';
}

export function uiRecoveryHref(): string {
  const path = window.location.pathname + window.location.search + window.location.hash;
  return '/ui-recovery.html?return=' + encodeURIComponent(path);
}
